import type { TableSemanticSchema } from './types';

export const EmpathySchema: TableSemanticSchema = {
  id: 'empathy',
  name: 'Empathy Map',
  description:
    'Dave Gray 6-section empathy map per persona. Pain / gain items feed directly into the Lean Canvas problem/value-proposition blocks.',
  cells: [
    { id: 'think_feel', label: 'Thinks & Feels', row: 0, col: 1 },
    { id: 'see', label: 'Sees', row: 1, col: 0 },
    { id: 'hear', label: 'Hears', row: 1, col: 2 },
    { id: 'say_do', label: 'Says & Does', row: 2, col: 1 },
    { id: 'pain', label: 'Pain', row: 3, col: 0 },
    { id: 'gain', label: 'Gain', row: 3, col: 2 },
  ],
  itemFields: [
    { key: 'section', label: 'Section', kind: 'enum', required: true,
      options: [
        { value: 'think_feel', label: 'Thinks & Feels' },
        { value: 'see', label: 'Sees' },
        { value: 'hear', label: 'Hears' },
        { value: 'say_do', label: 'Says & Does' },
        { value: 'pain', label: 'Pain' },
        { value: 'gain', label: 'Gain' },
      ] },
    { key: 'persona', label: 'Persona', kind: 'string', required: true },
    { key: 'intensity', label: 'Intensity', kind: 'number', description: '1 (mild) to 5 (acute)' },
  ],
  renderingHints: { layout: 'grid' },
};
